import { useContext } from 'react';

import CourseContext from './CourseContext';

export default function useCourseContext() {
  return useContext(CourseContext);
}
